import cn from 'clsx'
import React, { Component } from 'react'
import { getImageSrc } from '@disco/content-editor/editor-utils'

/**
 * RichTextImage component for rendering image entities in rich text editor
 *
 * A class component that displays images within the Draft.js editor with support for
 * configurable dimensions and fallback placeholder rendering. Uses the getImageSrc
 * utility to process image URLs and dimensions.
 *
 * @param props - Component props including block, theme, and Draft.js entity data
 * @returns JSX element containing either an image or empty placeholder
 */
export default class RichTextImage extends Component<any> {
  render() {
    const { block, className, theme = {}, ...otherProps } = this.props
    const {
      blockProps,
      customStyleMap,
      customStyleFn,
      decorator,
      forceSelection,
      offsetKey,
      selection,
      tree,
      contentState,
      blockStyleFn,
      ...elementProps
    } = otherProps
    const combinedClassName = cn(theme.image, className)
    const { src, width, height } = contentState
      .getEntity(block.getEntityAt(0))
      .getData()

    if (src) {
      const image = getImageSrc({
        src,
        width,
        height,
      })
      return (
        <img
          {...elementProps}
          src={image}
          width={width}
          role="presentation"
          className={combinedClassName}
        />
      )
    }

    return (
      <div
        {...elementProps}
        className={cn('content-editor__image-placeholder', combinedClassName)}
      >
        Empty image
      </div>
    )
  }
}
